import { render, staticRenderFns } from "./FilterBox.vue?vue&type=template&id=a245e49a"
import script from "./FilterBox.vue?vue&type=script&lang=js"
export * from "./FilterBox.vue?vue&type=script&lang=js"
import style0 from "./FilterBox.vue?vue&type=style&index=0&id=a245e49a&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/bitrix/ext_www/igr.ru/local/templates/main/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a245e49a')) {
      api.createRecord('a245e49a', component.options)
    } else {
      api.reload('a245e49a', component.options)
    }
    module.hot.accept("./FilterBox.vue?vue&type=template&id=a245e49a", function () {
      api.rerender('a245e49a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FilterBox.vue"
export default component.exports